<template>
  <div class="error-page">
    <img src="@/assets/images/empty.png" class="img-box" />
    <div>404</div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.error-page {
  margin: 300px auto;
  text-align: center;
}
.img-box {
  width: 160px;
  height: 172px;
  margin-bottom: 20px;
}
</style>
